import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";
import { useBranding } from "@/lib/branding";

const TITLES = { imprint: "Impressum", privacy: "Datenschutz­erklärung", terms: "AGB" };

export default function LegalPage() {
  const { doc_type } = useParams();
  const [data, setData] = useState(null);
  const { branding } = useBranding();

  useEffect(() => {
    api.get(`/branding/legal/${doc_type}`).then((r) => setData(r.data)).catch(() => setData({ content: "" }));
  }, [doc_type]);

  return (
    <div className="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950">
      <header className="sticky top-0 z-30 bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl border-b border-border/60">
        <div className="max-w-4xl mx-auto flex items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-3">
            {branding?.logo_b64 ? (
              <img src={branding.logo_b64} alt="logo" className="h-8 w-8 rounded-md object-contain" />
            ) : (
              <div className="h-8 w-8 rounded-md bg-blue-700 text-white grid place-items-center font-bold text-sm">Rx</div>
            )}
            <span className="font-heading font-bold">{branding?.system_name || "Apotheken Portal"}</span>
          </Link>
          <Link to="/dashboard" className="text-sm text-slate-500 flex items-center gap-1 hover:text-slate-900"><ArrowLeft className="w-4 h-4" /> Zurück</Link>
        </div>
      </header>
      <main className="flex-1 max-w-4xl mx-auto w-full px-6 py-10">
        <div className="overline mb-3">Rechtliches</div>
        <h1 className="font-heading text-4xl font-extrabold tracking-tight mb-6">{TITLES[doc_type] || doc_type}</h1>
        <article data-testid={`legal-content-${doc_type}`} className="prose prose-slate dark:prose-invert max-w-none">
          {data?.content ? (
            <div className="whitespace-pre-wrap text-slate-700 dark:text-slate-300 leading-relaxed">{data.content}</div>
          ) : (
            <p className="text-slate-500 italic">Dieser Bereich wurde noch nicht durch den Betreiber ausgefüllt.<br />Admins können den Text unter <strong>Branding → Recht</strong> pflegen.</p>
          )}
        </article>
      </main>
      <Footer />
    </div>
  );
}
